import { memo, useEffect, useRef } from 'react';
import { MapContainer, useMap } from 'react-leaflet';

import classnames from 'classnames';

import { useResizeObserver } from '../../hooks/useResizeObserver';

import useFullscreen from '../../components/Maps/useFullscreen';

import LoadingBar from '../LoadingBar';
import { ZOOM } from './constants';

function ResizeHandler() {
  const map = useMap();
  const containerRef = useRef(map.getContainer());

  useFullscreen();

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver(() => {
      map.invalidateSize();
    });

    observer.observe(containerRef.current);

    return () => {
      observer.disconnect();
    };
  }, [map]);

  return null;
}

const AppMapContainer = ({ children, className, height, loading = false }) => {
  return (
    <MapContainer
      attributionControl={false}
      style={{ height: height ?? '100%' }}
      className={classnames('map', className)}
      zoom={ZOOM}>
      <ResizeHandler />
      {loading ? <LoadingBar /> : <>{children}</>}
    </MapContainer>
  );
};

export default memo(AppMapContainer);
